import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Modal, Row, Col, Table } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { LAPI_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../../components/_utils/utils'
import university from '../../FollowUp/university'
const TabPane = Tabs.TabPane

let invoiceCounts = [1, 2, 3, 4, 5, 6, 7, 8];

@Form.create()

class AllCoursesCommissions extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universityId: '',
    universities: [],
    courses: [],
    applicantsList: [],
    commissionOwnerType: null,
    channelPartners: [],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getUniversityCourseCommissions({
        ...params,
        regExFilters: [
          'universityInstitutionName',
          'courseName'
        ]
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  handleSubmit = e => {
    const { form } = this.props;
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        values.commissionsArr = this.state.applicantsList;
        let x = null;

        if (this.state.id) {
          values._id = this.state.id;
          x = await Request.updateCourseCommission(values);
        } else {
          x = await Request.addCourseCommission(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Commission Updated Successfully`
              : 'Commission Added successfully'
          })
          if (!this.state.id) {
            this.setState({ applicantsList: [] }, () => {
              form.resetFields()
            });

          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteCommission = async data => {
    this.setState({ loading: true })
    await Request.deleteCourseCommission(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setCommissionData = async (commissionId) => {
    if (!commissionId) return;

    try {
      const response = await Request.getCourseCommissionById({ id: commissionId });

      if (response.error) {
        notification.error({
          message: 'Error Getting Data',
          description: response.message
        });
        return;
      }

      const doc = response.doc || {};

      // 1. पहले स्टेट सेट करें ताकि UI को पता चले कि 'University' सिलेक्टेड है
      this.setState({
        id: doc._id,
        activeTab: '1',
        commissionOwnerType: doc.commissionOwnerType,
        channelPartnerId: doc.channelPartnerId,
        universityId: doc.universityId,
        applicantsList: doc.commissionsArr || []
      });

      // 2. यहाँ है असली सुधार (Fix):
      if (doc.commissionOwnerType === "Channel Partner") {
        // अगर चैनल पार्टनर है, तो पार्टनर लोड करो और उसके अंडर की यूनिवर्सिटीज लाओ
        this.loadChannelPartner();
        await this.loadUniversity(doc.channelPartnerId);
      } else if (doc.commissionOwnerType === "University") {
        // अगर सीधे यूनिवर्सिटी है, तो बिना किसी पार्टनर आईडी के सीधे सारी यूनिवर्सिटीज लोड करो
        await this.loadUniversity();
      }

      // 3. यूनिवर्सिटी लोड होने के बाद उसके कोर्सेज लोड करें
      if (doc.universityId) {
        await this.loadUniversityCourses(doc.universityId);
      }

      // 4. अब जब सारा डेटा (Universities और Courses) ड्रापडाउन में आ चुका है, तब फॉर्म वैल्यूज सेट करें
      this.props.form.setFieldsValue({
        commissionOwnerType: doc.commissionOwnerType,
        channelPartnerId: doc.channelPartnerId,
        universityId: doc.universityId,
        courseId: doc.courseId,
        noOfInvoice: doc.noOfInvoice,
        invoicePerYear: doc.invoicePerYear,
        commissionFromCourse: doc.commissionFromCourse,
        commissionTypeFrom: doc.commissionTypeFrom,
        bonusAny: doc.bonusAny,
        bonusCondition: doc.bonusCondition,
        bonusAmount: doc.bonusAmount,
      });

    } catch (error) {
      console.error("Error in setCommissionData:", error);
      notification.error({
        message: 'Network Error',
        description: 'Failed to fetch or process commission data.'
      });
    }
  }
  // setCommissionData(commissionId) {
  //   if (commissionId) {
  //     Request.getCourseCommissionById({ id: commissionId }).then(
  //       ({ doc, error, message }) => {
  //         if (!error) {
  //           this.setState({
  //             id: doc._id,
  //             activeTab: '1',
  //           })

  //           this.setState({ commissionOwnerType: doc.commissionOwnerType, universityId: doc.universityId, applicantsList: doc.commissionsArr ? doc.commissionsArr : [] });
  //           if (doc.commissionOwnerType === "Channel Partner") {
  //             this.loadChannelPartner().then(() => {
  //               this.loadUniversityCourses(doc.universityId);
  //               this.props.form.setFieldsValue({
  //                 channelPartnerId: doc.channelPartnerId,
  //                 universityId: doc.universityId,
  //               });
  //             });
  //           }
  //           this.loadUniversityCourses(doc.universityId);

  //           this.props.form.setFieldsValue({
  //             commissionOwnerType: doc.commissionOwnerType,
  //             // channelPartnerId: doc.channelPartnerId,
  //             universityId: doc.universityId,
  //             courseId: doc.courseId,
  //             noOfInvoice: doc.noOfInvoice,
  //             invoicePerYear: doc.invoicePerYear,
  //             commissionFromCourse: doc.commissionFromCourse,
  //             commissionTypeFrom: doc.commissionTypeFrom,
  //             bonusAny: doc.bonusAny,
  //             bonusCondition: doc.bonusCondition,
  //             bonusAmount: doc.bonusAmount,
  //           })
  //         } else {
  //           notification.error({
  //             message: 'Error Getting Data',
  //             description: message
  //           })
  //         }
  //       }
  //     )
  //   }
  // }
  // async setCommissionData(commissionId) {
  //   if (!commissionId) return;

  //   try {
  //     const { doc, error, message } =
  //       await Request.getCourseCommissionById({ id: commissionId });

  //     if (error) {
  //       notification.error({
  //         message: 'Error Getting Data',
  //         description: message
  //       });
  //       return;
  //     }

  //     this.setState({
  //       id: doc._id,
  //       activeTab: '1',
  //       commissionOwnerType: doc.commissionOwnerType,
  //       universityId: doc.universityId,
  //       applicantsList: doc.commissionsArr || []
  //     });

  //     // Load dropdown data first
  //     if (doc.commissionOwnerType === "Channel Partner") {

  //       await this.loadChannelPartner();

  //       // Load universities of selected channel partner
  //       await this.loadUniversity(doc.channelPartnerId);

  //     } else {

  //       await this.loadUniversity();
  //     }

  //     // Load courses after university is loaded
  //     await this.loadUniversityCourses(doc.universityId);

  //     // Set form values LAST
  //     this.props.form.setFieldsValue({
  //       commissionOwnerType: doc.commissionOwnerType,
  //       channelPartnerId: doc.channelPartnerId,
  //       universityId: doc.universityId,
  //       courseId: doc.courseId,
  //       noOfInvoice: doc.noOfInvoice,
  //       invoicePerYear: doc.invoicePerYear,
  //       commissionFromCourse: doc.commissionFromCourse,
  //       commissionTypeFrom: doc.commissionTypeFrom,
  //       bonusAny: doc.bonusAny,
  //       bonusCondition: doc.bonusCondition,
  //       bonusAmount: doc.bonusAmount,
  //     });

  //   } catch (err) {
  //     notification.error({
  //       message: 'Error Getting Data',
  //       description: err.message || 'Something went wrong'
  //     });
  //   }
  // }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadUniversity = async (channelPartnerId = null) => {
    let rawUniversities;
    if (channelPartnerId) {
      let { data } = await Request.getChannelPartnerUniversities(channelPartnerId);
      rawUniversities = data;
    } else {
      let { arr } = await Request.loadSimpleUniversities({ sort: { instituteName: 1 } });
      rawUniversities = arr;
    }
    let universities = rawUniversities.reduce((temp, vv) => {
      temp.push({ _id: vv._id, display: vv.universityInstitutionName })
      return temp;
    }, []);
    this.setState({ universities });
    this.refreshFxn();
  }


  loadChannelPartner = async () => {
    let { data } = await Request.loadChannelPartners();
    data = data.reduce((temp, vv) => {
      temp.push({ _id: vv._id, display: vv.channelPartnerName });
      return temp;
    }, []);

    this.setState({ channelPartners: data });
  }

  // loadChannelPartner = async () => {
  //   Request.loadChannelPartners().then(resp => {
  //     console.log(resp);
  //   }).catch(err => {
  //     console.log(err);
  //   })
  // }
  loadUniversityCourses = async (universityId) => {
    Request.loadSimpleUniversityCourse(universityId)
      .then(resp => {
        let temp = [{ display: '---Select All---', id: 'all' }];
        resp.courses = resp.courses.reduce((el, vv) => {
          temp.push({ _id: vv._id, display: vv.courseName })
          return temp
        }, [])

        this.setState({ courses: resp.courses })
        this.refreshFxn()
      })
      .catch(err => {
        console.log(err)
      })
  }

  componentWillMount() {

  }

  async componentDidMount() {
    // await this.loadUniversity();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }

  handleReferenceSubmit = () => {
    let { form } = this.props;
    let applicantFromValues = form.getFieldsValue(['termNumber', 'commissionTypeFrom', 'commissionFromCourse'])
    if (!applicantFromValues.termNumber) {
      notification.error({
        message: 'Expect Term Number!'
      })
      return
    }
    if (!applicantFromValues.commissionTypeFrom) {
      notification.error({
        message: 'Expect Commission Type!'
      })
      return
    }
    if (!applicantFromValues.commissionFromCourse) {
      notification.error({
        message: 'Expect Commission Amount'
      })
      return
    }
    applicantFromValues.commissionFromCourse = parseFloat(applicantFromValues.commissionFromCourse);
    let applicantsList = this.state.applicantsList
    applicantsList.push(applicantFromValues)
    this.setState({ applicantsList, showApplicantModal: false }, () => {
      this.props.form.setFieldsValue({
        termNumber: null,
        commissionTypeFrom: null,
        commissionFromCourse: null,
      })
    });

  }

  removeCommissionRow = (index) => {
    this.setState((prevState) => {
      const updatedCommissions = [...prevState.applicantsList]; // copy array
      updatedCommissions.splice(index, 1); // remove item at index
      return { applicantsList: updatedCommissions };
    });
  };

  render() {
    const {
      form: { getFieldDecorator, setFieldsValue, getFieldValue }
    } = this.props
    const { universities, courses, id, commissionOwnerType, channelPartners, universityId } = this.state;
    const selectedChannelPartner = getFieldValue('channelPartnerId');
    const selectedUniversity = getFieldValue('universityId') || this.state.universityId;

    const inputTypes = {
      fields: [
        {
          label: 'Commission Of',
          key: 'commissionOwnerType',
          required: true,
          type: 'select',
          options: ['University', 'Channel Partner'],
          onChange: v => {
            this.setState({
              commissionOwnerType: v,
              universityId: null
            });

            this.props.form.setFieldsValue({
              commissionOwnerType: v,
              channelPartnerId: undefined,
              universityId: undefined,
              courseId: undefined,
              noOfInvoice: undefined,
              invoicePerYear: undefined
            });

            if (v === 'Channel Partner') {
              this.loadChannelPartner();
            } else {
              this.loadUniversity();
            }
          }
        },
        {
          label: 'Select Channel Partner',
          key: 'channelPartnerId',
          type: 'select',
          required: commissionOwnerType === 'Channel Partner',
          hidden: commissionOwnerType !== 'Channel Partner',
          options: channelPartners,
          showSearch: true,
          onChange: async v => {
            this.props.form.setFieldsValue({
              channelPartnerId: v,
              universityId: undefined,
              courseId: undefined
            });
            this.setState({ universityId: null });

            await this.loadUniversity(v);
          }
        },

        {
          label: 'Select University',
          key: 'universityId',
          required: true,
          type: 'select',
          showSearch: true,
          options: universities,
          hidden: !(
            commissionOwnerType === 'University' ||
            (commissionOwnerType === 'Channel Partner' && selectedChannelPartner)
          ),
          onChange: async v => {
            this.setState({ universityId: v });

            this.props.form.setFieldsValue({
              universityId: v,
              courseId: undefined
            });

            await this.loadUniversityCourses(v);
          }
        },

        {
          label: 'Select Course',
          key: 'courseId',
          required: true,
          type: 'select',
          showSearch: true,
          options: courses,
          hidden: !selectedUniversity,
          onChange: v => {
            this.props.form.setFieldsValue({ courseId: v });
          }
        },

        {
          label: 'No Of Invoices',
          key: 'noOfInvoice',
          type: 'select',
          required: true,
          options: invoiceCounts,
          hidden: !selectedUniversity,
          onChange: v => {
            this.props.form.setFieldsValue({ noOfInvoice: v });
          }
        },

        {
          label: 'Invoice Per Year',
          key: 'invoicePerYear',
          type: 'select',
          required: true,
          options: invoiceCounts,
          hidden: !selectedUniversity,
          onChange: v => {
            this.props.form.setFieldsValue({ invoicePerYear: v });
          }
        }
      ]
    };



    const columns = [
      {
        title: 'Channel Partner',
        key: 'channelPartnerName',
        width: 200,
        dataIndex: 'channelPartnerName',
        searchTextName: 'Channel Partner',
        render: (text) => (
          <div>{text ? text : 'N/A'}</div>
        )
      },
      {
        title: 'University Name',
        key: 'universityInstitutionName',
        width: 200,
        dataIndex: 'universityInstitutionName',
        searchTextName: 'University Name',
      },
      {
        title: 'Course Name',
        key: 'courseName',
        width: 200,
        dataIndex: 'courseName',
        searchTextName: 'Course Name',
      },
      {
        title: 'Commission',
        width: 200,
        key: 'commissionFromCourse',
        dataIndex: 'commissionsArr',
        render: (text, record) => (
          <>
            {record.commissionsArr && record.commissionsArr.map((item, index) => (
              <div key={index}>
                Term {item.termNumber} : {item.commissionFromCourse}{item.commissionTypeFrom === "Percentage" ? `(%)` : '(Flat)'}
              </div>
            ))}
          </>
        )
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        width: 150,
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Status',
        key: 'status',
        width: 120,
        filters: [
          { value: 'Active', text: 'Active' },
          { value: 'Pending', text: 'Pending' }
        ],
      },
      {
        title: 'Action',
        key: 'operation',
        width: 150,
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeCourseCommission.edit'}>
              <Tooltip title="Edit Commission">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setCommissionData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeCourseCommission.delete'}>
              <Tooltip title="Delete Commission">
                <Popconfirm
                  title="Are you sure delete this Commission?"
                  onConfirm={() => {
                    this.deleteCommission({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]

    const applicantListColumns = [
      {
        title: 'Term Number',
        key: 'termNumber',
        dataIndex: 'termNumber'
      },
      {
        title: 'Commission Type',
        key: 'commissionTypeFrom',
        dataIndex: 'commissionTypeFrom',
      },
      {
        title: 'Commission Amount',
        key: 'commissionFromCourse',
        dataIndex: 'commissionFromCourse',
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record, index) => (
          <Tooltip title="Delete Commission">
            <Button
              className={styles.btn}
              shape="circle"
              onClick={() => {
                this.removeCommissionRow(index)
              }}
              icon="delete"
            />
          </Tooltip>
        )
      }
    ]

    const newComissionSchema = {
      fields: [
        {
          label: 'Term Number',
          key: 'termNumber',
          type: 'select',
          options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          // required: true,
          onChange: v => {
            this.props.form.setFieldsValue({ termNumber: v });
          }
        },
        {
          label: 'Commission Type',
          key: 'commissionTypeFrom',
          type: 'select',
          // required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Flat', 'Percentage'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              commissionTypeFrom: v
            })
          }
        },
        {
          label: 'Commission Amount / %',
          key: 'commissionFromCourse',
          // required: true
        }
      ]
    }
    return (
      <PageHeaderWrapper title={` Course Wise Commissions `}>
        <Card bordered={true}>
          <p style={{ color: 'red' }}>Course Commission not required, if you have entered University Commission, it will be calculated automatically based on the University.</p>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Commissions`} key={0}>
              <h2>{`Commissions : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Commission'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.setState({ applicantsList: [] }, () => {
                      this.props.form.resetFields();
                    });
                  }}>
                  RESET
                </Button>

              </Form>
              <Card>
                <div className={"applicantsItem"}>
                  <Button type='primary' onClick={() => this.setState({ showApplicantModal: true })}>Click to add</Button>
                  <Modal
                    title="Applicant Details"
                    visible={this.state.showApplicantModal}
                    onCancel={() => this.setState({ showApplicantModal: false })}
                    onOk={() => this.setState({ showApplicantModal: false })}
                    footer={[<Button
                      type="primary"
                      onClick={() => this.handleReferenceSubmit()}
                      style={{ marginBottom: 10 }}
                      loading={this.props.loading}>
                      SAVE
                    </Button>]}
                  >
                    <Form>
                      <GetAllFormFields apiurl={LAPI_URL} inputSchema={newComissionSchema} getFieldDecorator={getFieldDecorator} />
                    </Form>
                  </Modal>
                </div>
                <Row style={{ marginTop: 40 }}>
                  <Col span={24}>
                    <Table
                      bordered={true}
                      style={{ width: '100%' }}
                      columns={applicantListColumns}
                      dataSource={this.state.applicantsList}
                      pagination={false}
                    />
                  </Col>
                </Row>
              </Card>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllCoursesCommissions
